import MenuVTC from "../../../Share/Component/MenuVtc";
import { Path } from "../../../Api/Path";
import clsx from "clsx";
import Styles from "./Payment.module.scss";
import usePaymentPage from "../../../Hooks/usePaymentPage";
import { login } from "../../../Api/SubUrl";
function Payment() {
  const { newDetail, TextToHtml } = usePaymentPage();

  return (
    <div style={{ backgroundColor: "#000" }}>
      <div className={clsx(Styles.wrapperHome)}>
        <div className={clsx(Styles.wrapperInner)}>
          <div className={clsx(Styles.contentMain)}>
            <div className={clsx(Styles.detailContent)}>
              <div className={clsx(Styles.head)}>
                <h3 style={{ textAlign: "center" }}>{newDetail.Title}</h3>
              </div>
              <div className={clsx(Styles.body)}>
                <img
                  alt="img"
                  className={clsx(Styles.img)}
                  src={Path.imageCDN + newDetail.Img}
                />
                <div className={clsx(Styles.btnSubmit)}>
                  <a className={clsx(Styles.btn)} href={login}>
                    Đăng nhập để thêm Xu
                  </a>
                </div>
                {TextToHtml(newDetail.Description)}
              </div>
              {/* <div className={clsx(Styles.newDetailIframe)}>
                <iframe
                  title="video"
                  className={clsx(Styles.responsiveIframe)}
                  src="https://www.youtube.com/embed/ZoLxWljG3RQ"
                ></iframe>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <MenuVTC />
    </div>
  );
}

export default Payment;
